import { Typography } from "@mui/material";
import { COPYRIGHT_MESSAGE } from "../../constants";

function GuestPageFooter() {
    return <Typography className="text-[#455468] p-[20px] mx-auto text-[12px]">{COPYRIGHT_MESSAGE}</Typography>;
}

export default GuestPageFooter;
